


import React, { useState, useEffect } from "react";
import { Box, Typography, Button, Link, IconButton, useMediaQuery } from "@mui/material";
import { styled } from "@mui/system";
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import ArrowForward from '@mui/icons-material/ArrowForward';
import appStore from '../Assets/appStore.png';
import googlePlay from '../Assets/googlePlay.png';
import phone from '../Assets/phone.png';
import labex from '../Assets/labex.png';
import farm from '../Assets/farm.png';
import meklit from '../Assets/meklit.png';
import ajt from '../Assets/ajt.jpeg';

const CustomButton = styled(Button)({
  background: '#17273F',
  color: '#fff',
  padding: { xs: '8px 16px', sm: '12px 24px' },
  borderRadius: '10px',
  textTransform: 'none',
  fontWeight: 'bold',
  boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.3)',
  '&:hover': {
    background: 'linear-gradient(135deg, #17273F 0%, #4b5d77ff 100%)',
    transform: 'scale(1.05)',
    boxShadow: '0px 6px 10px rgba(0, 0, 0, 0.4)',
  },
});

const LinkButton = styled('a')({
  display: 'flex',
  alignItems: 'center',
  margin: { xs: '0 4px', sm: '0 8px' },
  padding: { xs: '6px 12px', sm: '8px 16px' },
  borderRadius: '8px',
  backgroundColor: '#f5f5f5',
  textDecoration: 'none',
  transition: 'background-color 0.3s',
  '& img': {
    width: { xs: '20px', sm: '24px' },
    height: 'auto',
    marginRight: '8px',
  },
  '&:hover': {
    backgroundColor: '#e0e0e0',
  },
});

const SpacerBox = styled(Box)({
  height: { xs: '10px', sm: '30px' },
});


const Products = React.forwardRef((props, ref) => {
  const [activeSection, setActiveSection] = useState(0);
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  const sections = [
    {
      title: "Discover OwlEvents",
      description: "OwlEvents is a digital platform designed to streamline the process of planning, managing and coordinating events of various types and sizes.",
      image: phone,
      appStoreLink: "https://www.apple.com/app-store/",
      googlePlayLink: "https://play.google.com/store",
      websiteLink: "https://owlevents.app/",
    },
    {
      title: "Discover LabExAfrica",
      description: "LabExAfrica is a project we did to streamline the process of planning, managing and coordinating events of various types and sizes.",
      image: labex,
      appStoreLink: "https://www.apple.com/app-store/",
      googlePlayLink: "https://play.google.com/store",
      websiteLink: "https://soyoafricabiotech.com/about/"
    },
    {
      title: "Discover MFS",
      description: "MFS is a digital platform designed to streamline the process of agricultural management and coordination.",
      image: farm,
      appStoreLink: "https://www.apple.com/app-store/",
      googlePlayLink: "https://play.google.com/store",
      websiteLink: "https://maed.farm/auth/login",
    },
    {
      title: "Discover Meklit",
      description: "Meklit is a digital platform designed to streamline various health conditions regarding women and children.",
      image: meklit,
      appStoreLink: "https://www.apple.com/app-store/",
      googlePlayLink: "https://play.google.com/store",
      websiteLink: "https://meklit.life/",
    },
    // {
    //   title: "Discover AJT",
    //   description: "Africa's Jewel Tours offers immersive experiences in Ethiopia's beauty and culture",
    //   image: ajt,
    //   appStoreLink: "https://www.apple.com/app-store/",
    //   googlePlayLink: "https://play.google.com/store",
    //   websiteLink: "https://africasjeweltour.com",
    // },
  ];


  useEffect(() => {
    const interval = setInterval(() => {
      setActiveSection((prev) => (prev + 1) % sections.length);
    }, 6000);
    return () => clearInterval(interval);
  }, [sections.length]);

  const handleDotClick = (index) => {
    setActiveSection(index);
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Enter" || e.key === " ") {
      handleDotClick(index);
    }
  };

  const currentSection = sections[activeSection];

  return (
    <Box
      ref={ref}
      sx={{
        marginTop: { sm: '4px', md: '56px' },
        minHeight: { sm: '95vh', md: 'auto'},
        my: { xs: 2, sm: 4 , md: 10 },
        width: '100%',
        bgcolor: 'linear-gradient(135deg, #eef2ff 0%, #ede9fe 100%)',
        overflow: 'hidden',
        py: { xs: 2, sm: 0},
   
        
        
      }}
    >
      <Box
        sx={{
          position: 'relative',
          mx: 'auto',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography
          variant="h4"
          sx={{
            fontWeight: 'bold',
            fontSize: { xs: '24px', sm: '30px', md: '40px' },
            mb: 2,
            color: '#1a1a1a',
            textAlign: 'center',
            borderBottom: "3px solid #17273F"
          }}
        >
          Products
        </Typography>
     
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            height: { xs: 'auto', sm: '738px' ,md: '472px'},
            minHeight: { xs: '438px', sm: '500px' }, 
            overflow: 'visible',
            mt: 2,
            backgroundColor: '#FFFFFF',
          }}
        >
          {sections.map((section, index) => (
            <Box
              key={index}
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'all 0.5s ease-in-out',
                opacity: index === activeSection ? 1 : 0,
                transform: `translateX(${(index - activeSection) * 100}%)`,
                p: { xs: 1, sm: 4 },
              }}
            >
              <Box
                sx={{
                  maxWidth: { xs: '80%', sm: '500px' },
                  pr: { sm: 4 },
                  transition: 'all 0.5s',
                  '&:hover': { transform: 'translateY(-8px)' },
                }}
              >
                <Typography
                  variant="h5"
                  sx={{
                    color: '#000000',
                    fontWeight: 'bold',
                    fontSize: { xs: '22px', sm: '49px', md: '49px' },
                    mb: 1,
                  }}
                >
                  {section.title}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { xs: '12px', sm: '18px' },
                    color: '#4a4a4a',
                    mb: 2,
                  }}
                >
                  {section.description}
                </Typography>
                <Link href={section.websiteLink} target="_blank" rel="noopener noreferrer">
                  <CustomButton
                    variant="contained"
                    sx={{
                      maxWidth: '200px',
                      width: '100%',
                      py: { xs: 1, sm: 1.5 },
                      px: { xs: 2, sm: 3 },
                      fontSize: { xs: '12px', sm: '14px' },
                    }}
                  >
                    Get Started
                  </CustomButton>
                </Link>
              </Box>
              <Box
                sx={{
                  height: { xs: '250px', md: '450px' },
                  width: { xs: '250px', md: '550px' },
                  overflow: 'hidden',
                  mt: { xs: 2, sm: 0 },
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <img
                  src={section.image}
                  alt={section.title}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                    transition: 'transform 0.5s',
                    '&:hover': { transform: 'scale(1.05)' },
                  }}
                  loading="lazy"
                  onError={(e) => { e.target.src = phone; }}
                />
              </Box>
            </Box>
          ))}
        </Box>
        {/* {currentSection.title === "Discover OwlEvents" && (
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2, gap: 1, flexWrap: 'wrap' }}>
            <LinkButton href={currentSection.googlePlayLink} target="_blank" rel="noopener noreferrer">
              <img src={googlePlay} alt="Get it on Google Play" />
              <Typography sx={{ color: '#000', fontSize: { xs: '10px', sm: '12px' } }}>
                Get it on Google Play
              </Typography>
            </LinkButton>
            <LinkButton href={currentSection.appStoreLink} target="_blank" rel="noopener noreferrer">
              <img src={appStore} alt="Download on the App Store" />
              <Typography sx={{ color: '#000', fontSize: { xs: '10px', sm: '12px' } }}>
                Download on the App Store
              </Typography>
            </LinkButton>
          </Box>
        )} */}
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2, gap: 1 ,mb:4}}>
                {sections.map((_, index) => {
                const distance = index <= activeSection ? 0 : index - activeSection;
                const maxDistance = 2;
                const clampedDistance = Math.min(distance, maxDistance);
                const size = index <= activeSection ? 8 : 8 - clampedDistance ;
                const opacity = index <= activeSection ? 1 : 1 - clampedDistance * 0.25;
                const color = index === activeSection ? '#000' : '#9e9e9e';
        return (
          <IconButton
            key={index}
            onClick={() => handleDotClick(index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            sx={{
              width: size,
              height: size,
              bgcolor: color,
              opacity,
              borderRadius: '50%',
              transition: 'all 0.3s ease',
              p: 0,
              m: 0.5,
              '&:hover': {
                opacity: 1,
              },
            }}
            aria-label={`Go to slide ${index + 1}`}
            tabIndex={0}
          />
        );
      })}

        </Box>
        <SpacerBox />
      </Box>
      <style jsx global>{`
        @keyframes bounce {
          0%, 100% { transform: translateX(0); }
          50% { transform: translateX(8px); }
        }
      `}</style>
    </Box>
  );
});

export default Products;